import React, {useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {useAuth} from '../../../contexts/AuthContext';
import { authErrorMessage } from '../../../utils/authErrorMessage';

const styles = {
  paper: {
    marginTop: '128px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  error: {
    color: 'red'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: '8px',
  },
  submit: {
    margin: 'auto',
    marginTop: '16px',
  }
};

export default function SignUp() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const emailRef = useRef();
  const passwordRef = useRef();

  const handleSubmit = (e) => {
      e.preventDefault();
      setLoading(true)
      signUp(emailRef.current.value, passwordRef.current.value).then(()=>{
        setLoading(false)
        navigate("/");
      }, (error) => {
        setError(authErrorMessage(error, 'Could not create the account. Please try again.'));
        setLoading(false);
      });
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div style={styles.paper}>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <form style={styles.form} onSubmit={handleSubmit} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            inputRef={emailRef}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            inputRef={passwordRef}
          />
          { error && 
          <Typography style={styles.error} component="h5">
            {error}
          </Typography>
          }
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            style={styles.submit}
            disabled={loading}
          >
            Sign Up
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid>
              <Link href="/login" variant="body2">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
}